import styled from 'styled-components';

// Images
import InstagramLogoSource from '../../../images/instagram.svg';

const InstagramLogo = styled(InstagramLogoSource)`
  max-width: 100%;
  height: auto;

  path {
    fill: var(--colors-mischka);
    fill-opacity: 0.7;
  }
`;

export default InstagramLogo;
